<template>
	<v-container fluid >
		<v-toolbar flat class="mb-6">
		<!-- <v-app-bar class="mb-6" fixed> -->	
			<v-app-bar-nav-icon :to="{ name: 'Dictionaries' }">
				<v-icon large :color="color">{{ icon }}</v-icon>
			</v-app-bar-nav-icon>
			<v-toolbar-title>
				<div class="text-h6">{{ title }}</div>
				<div class="text-subtitle-2 font-weight-light">{{ subtitle }}</div>
			</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-text-field
				v-model.trim="search"
				append-icon="mdi-magnify"
				label="Search"
				single-line
				hide-details
				clearable
				@click:append="onSearch"
				@keyup.enter="onSearch"
			></v-text-field>

			<template v-slot:extension>
				<v-row no-gutters>
					<v-col cols="12">
						<v-btn text small v-for="letter in alphabet_en" :key="letter" :value="letter" @click="onFilterByLetter(letter)">{{ letter }}</v-btn>
					</v-col>
					<v-col cols="12">
						<v-btn text small v-for="letter in alphabet_uk" :key="letter" :value="letter" @click="onFilterByLetter(letter)">{{ letter }}</v-btn>
					</v-col>
				</v-row>
			</template>
		<!-- </v-app-bar> -->
		</v-toolbar>
		<v-data-table
			v-model="selected"
			:headers="headers"
			:items="items"
			show-select
			:loading="loading"
			loading-text="Loading... Please wait"
		>
			<template v-slot:item.datebegin="{ item, index }">
				<span>{{ item.datebegin | formatDate }}</span>
			</template>
			<template v-slot:item.dateend="{ item, index }">
				<span>{{ item.dateend | formatDate }}</span>
			</template>
		</v-data-table>
	</v-container>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import downloadExcel from "vue-json-excel"
import zVehicleParameters from '@/views/forms/vehicle.parameters.ai'
import zDetail from '@/views/dialogs/details/VehiclePark2'
import zConfirmDelete from '@/views/components/dialogs/ConfirmDelete'

export default {
	name: 'Drug',
	//mixins: [mixin],
	components: {
		zVehicleParameters,
		downloadExcel,
		zDetail,
		zConfirmDelete,
	},
	data: () => ({
		title: 'Медикаменти',
		subtitle: 'Реєстр медикаментів та лікарських форм',
		icon: 'mdi-pill',
		color: 'green darken-1',
		loading: false,

		search: null,

		selected: [],
		headers: [
			//{ text: 'ID', value: 'id', align: ' d-none' },
			{ text: 'ID', value: 'id', sortable: true},
			{ text: 'Код Моріон', value: 'idMorion', sortable: true},
			{ text: 'Назва', value: 'name', sortable: true},
			{ text: 'Форма випуску', value: 'form', sortable: true},
			{ text: 'Виробник', value: 'maker.name', sortable: true},
			{ text: 'Заявник', value: 'holder.name', sortable: true},
			{ text: 'Номер Реєстраційного посвідчення', value: 'registrationNumber', sortable: true},
			//{ text: 'Дата реєстрації', value: 'datereg', sortable: true},
			{ text: 'Термін дії реєстраційного посвідчення з', value: 'datebegin', sortable: true},
			{ text: 'Термін дії реєстраційного посвідчення по', value: 'dateend', sortable: true},
			{ text: 'Міжнародна непатентована назва', value: 'inn.name', sortable: true},
			{ text: 'АТС', value: 'atc.code', sortable: true},
			{ text: 'NFC', value: 'nfc.code', sortable: true},
			//{ text: 'Державний реєстр лікарських засобів України', value: 'drlz.name', sortable: true},
			//{ text: 'Чи є препарат рецептурним', value: 'isPrescription', sortable: true},
			//{ text: 'Дозволено рекламування', value: 'isAdvertise', sortable: true},
			//{ text: 'Державна закупівля', value: 'isBudget', sortable: true},
			{ text: '', value: 'actions', sortable: false },
/*
	id 							BIGINT NOT NULL AUTO_INCREMENT COMMENT 'Unique identifier'
	,name 						VARCHAR(128) NOT NULL  	COMMENT 'Назва'
	,form						VARCHAR(128)  			COMMENT 'Форма випуску'
	,datereg					DATE 					COMMENT 'Дата реєстрації'
	,datebegin 					DATE  					COMMENT 'Термін дії реєстраційного посвідчення'
	,dateend 					DATE  					COMMENT 'Термін дії реєстраційного посвідчення'
	,registration_number		CHAR(32) 				COMMENT 'Номер реєстраційного посвідчення (наприклад, UA/12345/01/01)'
	,inn_id 					BIGINT  				COMMENT 'Міжнародна непатентована назва'
	,atc_id 					BIGINT					COMMENT 'АТС Класифікація'
	,nfc_id 					BIGINT					COMMENT 'NFC Класифікація'
	,drlz_id 					BIGINT					COMMENT 'Державний реєстр лікарських засобів України'
	,maker_id 					BIGINT  				COMMENT 'Виробник'
	,holder_id 					BIGINT  				COMMENT 'Заявник'
	,is_prescription			TINYINT(1) 				COMMENT 'Чи є препарат рецептурним'
	,is_advertise				TINYINT(1) 				COMMENT 'Дозволено рекламування'
	,is_budget					TINYINT(1) 				COMMENT 'Належність лікарського засобу до лікарських засобів, які закуповуються відповідно до абзацу сімнадцятого частини третьої статті 2 Закону України «Про здійснення державних закупівель»' # IS_BUDGET
	,description 				VARCHAR(1024)           COMMENT 'Опис'
	,id_morion					BIGINT 					COMMENT 'Код Моріон'
	,id_external				BIGINT					COMMENT 'Ідентифікатор зовнішньої системи'
	,datecreate 				DATETIME DEFAULT current_timestamp() COMMENT 'Дата створення'
			*/
		],

		items: [],
	}),
	
	computed: {
		//...mapGetters('VehiclePark', [ 'items' ]),
		alphabet_en() {
			const alphabet = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i));
			return alphabet
		},

		alphabet_uk() {
			const alphabet = "АБВГҐДЕЄЖЗІЇЙКЛМНОПРСТУФХЦЧШЩЮЯ".split("");
			return alphabet
		},
	},

	created () {
		//this.loadLevel1()
	},

	methods: {
		//...mapActions(['showMessage']),
		//...mapActions('VehiclePark', [ 'search', 'delete' ]),

		//--------------------------------------------------------------------

		onSearch() {
			//console.log(this.$options.name, 'loadModels','item1', item1)

			this.selected = [];

			//Формування параметрів
			let params = { search: this.search }

			//Спроба перетворити рядок на масив
			const arr = this.search.split(/[ ,;\t]+/).map(Number);
			if(Array.isArray(arr)) {
				// Перевірка чи всі елементи масиву є цілими числами 
				if(arr.every(Number.isInteger)) {
					// Якщо так, то це перелік кодів Моріон
					params = { idMorion: arr }
				}
			}
			
			let that = this
			this.loading = true
			axios.get('/drug', { params: params}).then(response => {
				//console.log(that.$options.name, 'loadLevel5','response.data', response.data)
				that.items = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading = false));
			
		},

		onFilterByLetter(letter){
			//console.log(this.$options.name, 'onFilterByLetter','letter', letter)
			let that = this
			this.loading = true
			axios.get('/drug', { params: { letter: letter }}).then(response => {
				//console.log(that.$options.name, 'loadLevel5','response.data', response.data)
				that.items = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading = false));
		},
	},
}
</script>